(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wa-mobile-contact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wa-mobile-contact')) {
    customElements.define('wa-mobile-contact', class extends HTMLElement {
      connectedCallback() {
        if (document.querySelector('wa-mobile-contact') !== this) { this.hidden = true; return; }
        this.bar = this.querySelector('.wa-mobile-contact__bar');
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        this.mutations = new MutationObserver(this.queue);
        this.mutations.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden']});
        this.resize = new ResizeObserver(this.queue);
        this.resize.observe(this.bar);
        window.addEventListener('resize', this.queue, {passive: true});
        window.visualViewport?.addEventListener('resize', this.queue, {passive: true});
        document.addEventListener('focusin', this.queue);
        document.addEventListener('focusout', this.queue);
        this.update();
      }
      disconnectedCallback() {
        this.mutations?.disconnect();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        window.removeEventListener('resize', this.queue);
        window.visualViewport?.removeEventListener('resize', this.queue);
        document.removeEventListener('focusin', this.queue);
        document.removeEventListener('focusout', this.queue);
      }
      update() {
        if (!window.matchMedia('(max-width: 749px)').matches) { this.removeAttribute('data-obscured'); return; }
        const rect = this.bar.getBoundingClientRect();
        const space = `${Math.ceil(rect.height)}px`;
        if (this.style.getPropertyValue('--wa-contact-space') !== space) this.style.setProperty('--wa-contact-space', space);
        const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const keyboard = window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
        const isVisible = (element) => {
          if (this.contains(element)) return false;
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
          if (element.checkVisibility && !element.checkVisibility({checkOpacity: true, checkVisibilityCSS: true})) return false;
          const bounds = element.getBoundingClientRect();
          return bounds.width > 0 && bounds.height > 0;
        };
        const modalSelectors = 'cart-drawer.active, #Details-menu-drawer-container[open], details-modal details[open], modal-dialog[open], dialog[open], [aria-modal="true"]:not([aria-hidden="true"])';
        const themeModal = Array.from(document.querySelectorAll(modalSelectors)).some(isVisible);
        const overlaySelectors = '#shop-hcaptcha-badge-container, #shopify-pc__banner, #shopify-pc__prefs, #ShopifyChat, shopify-chat, iframe[title*="chat" i]';
        const overlapping = Array.from(document.querySelectorAll(overlaySelectors)).some((element) => {
          if (!isVisible(element)) return false;
          const other = element.getBoundingClientRect();
          return other.left < rect.right && other.right > rect.left && other.top < rect.bottom && other.bottom > rect.top;
        });
        this.toggleAttribute('data-obscured', Boolean(editing || keyboard || themeModal || overlapping));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["werke-service-request-event"] && !Shopify.designMode) return;
  try {
    (() => {
  const guard = '__werkeServiceRequestPublisherV2';
  if (window[guard]) return;
  window[guard] = true;

'use strict';

// Read-only extraction. Duplicate _fbp cookies are ambiguous and rejected.
// No decoding, creation, cookie write, raw-cookie storage or logging occurs.
function readWerkeExistingFbpCookie(cookieText) {
  if (typeof cookieText !== 'string' || cookieText.length > 32768) return null;
  const matches = [...cookieText.matchAll(/(?:^|;\s*)_fbp=([^;]*)/g)];
  if (matches.length !== 1) return null;
  return /^fb\.[0-2]\.[0-9]{13}\.[0-9]{1,30}$/.test(matches[0][1]) ? matches[0][1] : null;
}

// Factory is embedded in the generated native-success Liquid candidate.
function createWerkeServiceRequestTransport(config, runtime) {
  const eventName = 'werke_autosport:service_request_accepted';
  const ids = /^(?:[a-f0-9]{32}|[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12})$/;
  const forms = new Set(['pagefly_service_request', 'pagefly_home_service_request']);
  const attempts = new Set();
  const withdrawalCandidates = new Set();
  const withdrawals = new Set();
  let endpoint, withdrawalEndpoint;
  try {
    if (config.enabled !== true || !config.serviceEndpoint || !config.approvedReceiverOrigin) return null;
    if (!['https://werkeautosport.com', 'https://www.werkeautosport.com'].includes(runtime.currentOrigin)) return null;
    if (typeof runtime.fetch !== 'function' || typeof runtime.customerPrivacy !== 'function') return null;
    const target = new URL(config.serviceEndpoint);
    const approved = new URL(config.approvedReceiverOrigin);
    if (approved.origin !== config.approvedReceiverOrigin || approved.protocol !== 'https:') return null;
    if (target.origin !== approved.origin || target.protocol !== 'https:' || target.username || target.password) return null;
    if (target.pathname !== '/v1/service-requests' || target.search || target.hash || target.href !== config.serviceEndpoint) return null;
    endpoint = target.href;
    withdrawalEndpoint = approved.origin + '/v1/withdrawals';
  } catch (_) { return null; }

  function permitted() {
    try {
      const privacy = runtime.customerPrivacy();
      const methods = ['analyticsProcessingAllowed', 'marketingAllowed', 'saleOfDataAllowed'];
      return Boolean(privacy && methods.every((key) => typeof privacy[key] === 'function' && privacy[key]() === true));
    } catch (_) { return false; }
  }

  function request(url, payload) {
    try {
      return Promise.resolve(runtime.fetch(url, {
        method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error',
        referrerPolicy: 'no-referrer', cache: 'no-store', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      })).then(() => undefined, () => undefined);
    } catch (_) { return Promise.resolve(); }
  }

  function existingMetaContext() {
    try {
      if (!permitted() || typeof runtime.readFbp !== 'function') return null;
      const fbp = runtime.readFbp();
      if (typeof fbp !== 'string' || !/^fb\.[0-2]\.[0-9]{13}\.[0-9]{1,30}$/.test(fbp)) return null;
      if (!permitted() || typeof runtime.userAgent !== 'function') return null;
      const userAgent = runtime.userAgent();
      if (typeof userAgent !== 'string' || !/^[\x20-\x7e]{1,512}$/.test(userAgent)) return null;
      return { fbp, client_user_agent: userAgent };
    } catch (_) { return null; }
  }

  function existingGA4Context() {
    if (!permitted() || config.ga4MeasurementId !== 'G-1P78QXZTRD') return Promise.resolve(null);
    if (typeof runtime.getGtag !== 'function' || typeof runtime.setTimeout !== 'function' || typeof runtime.clearTimeout !== 'function') return Promise.resolve(null);
    return new Promise((resolve) => {
      let settled = false, timer = null, timeout = null, probes = 0;
      const finish = (value) => {
        if (settled) return;
        settled = true;
        for (const handle of [timer, timeout]) {
          if (handle !== null) { try { runtime.clearTimeout(handle); } catch (_) {} }
        }
        const valid = permitted() && typeof value === 'string' && /^[1-9][0-9]{0,19}\.[1-9][0-9]{0,19}$/.test(value);
        resolve(valid ? { client_id: value } : null);
      };
      const probe = () => {
        if (settled) return;
        if (!permitted()) { finish(null); return; }
        probes += 1;
        try {
          const gtag = runtime.getGtag();
          if (typeof gtag === 'function') {
            gtag('get', config.ga4MeasurementId, 'client_id', (value) => {
              if (typeof value === 'string' && /^[1-9][0-9]{0,19}\.[1-9][0-9]{0,19}$/.test(value)) finish(value);
            });
          }
        } catch (_) {}
        if (!settled && probes < 12) timer = runtime.setTimeout(probe, 250);
      };
      timeout = runtime.setTimeout(() => finish(null), 3000);
      probe();
    });
  }

  function reportAcceptedToGoogle(payload) {
    if (!permitted()) return;
    const page = payload.form_id === 'pagefly_home_service_request' ? '/' : '/pages/contact-us';
    try {
      const gtag = runtime.getGtag();
      if (typeof gtag !== 'function') return;
      gtag('event', 'werke_service_request_accepted', {
        send_to: config.ga4MeasurementId,
        form_id: payload.form_id,
        page_location: 'https://www.werkeautosport.com' + page,
        page_referrer: '',
      });
    } catch (_) {}
  }

  function withMatching(payload, id) {
    if (config.matchingEnabled !== true) return request(endpoint, payload);
    const meta = existingMetaContext();
    return existingGA4Context().then((ga4) => {
      // Context retrieval may be asynchronous: recheck immediately before fetch.
      // Any known withdrawal also prevents a re-grant from replaying this event.
      if (!permitted() || withdrawals.has(id)) return;
      if (ga4 !== null) reportAcceptedToGoogle(payload);
      if (ga4 !== null || meta !== null) {
        payload.schema_version = 2;
        payload.matching = { ga4, meta };
      }
      return request(endpoint, payload);
    }, () => undefined);
  }

  function rememberAttemptForWithdrawal(record) {
    // Recover only an existing, unexpired attempted record. This never writes
    // browser storage, changes its age, queues analytics, or triggers a send.
    try {
      if (!record || typeof record !== 'object' || Array.isArray(record)) return false;
      const expected = ['id', 'created_at', 'state'];
      const keys = Reflect.ownKeys(record);
      if (keys.length !== 3 || keys.some((key) => !expected.includes(key))) return false;
      if (keys.some((key) => !Object.hasOwn(Object.getOwnPropertyDescriptor(record, key), 'value'))) return false;
      if (record.state !== 'attempted' || typeof record.id !== 'string' || !ids.test(record.id)) return false;
      if (!Number.isSafeInteger(record.created_at)) return false;
      const now = typeof runtime.now === 'function' ? runtime.now() : Date.now();
      if (!Number.isSafeInteger(now) || now < record.created_at || now - record.created_at > 30 * 60 * 1000) return false;
      if (withdrawalCandidates.size >= 64 && !withdrawalCandidates.has(record.id)) return false;
      withdrawalCandidates.add(record.id);
      return true;
    } catch (_) { return false; }
  }

  function send(data) {
    try {
      if (!permitted() || !data || typeof data !== 'object' || Array.isArray(data)) return;
      const expected = ['schema_version', 'submission_id', 'form_id'];
      const keys = Reflect.ownKeys(data);
      if (keys.length !== 3 || keys.some((key) => !expected.includes(key))) return;
      if (keys.some((key) => !Object.hasOwn(Object.getOwnPropertyDescriptor(data, key), 'value'))) return;
      if (data.schema_version !== 1 || typeof data.submission_id !== 'string' || !ids.test(data.submission_id)) return;
      if (typeof data.form_id !== 'string' || !forms.has(data.form_id)) return;
      if (attempts.has(data.submission_id) || withdrawals.has(data.submission_id) || attempts.size >= 64) return;
      const payload = {
        event_name: eventName, schema_version: 1, submission_id: data.submission_id,
        form_id: data.form_id, consent: { analytics: true, marketing: true, sale_of_data: true },
      };
      // Repeat all three permissions after validation, immediately before send.
      if (!permitted()) return;
      attempts.add(data.submission_id);
      withdrawalCandidates.add(data.submission_id);
      return withMatching(payload, data.submission_id);
    } catch (_) { return; }
  }

  function withdrawKnownAttempts() {
    if (permitted()) return;
    for (const id of withdrawalCandidates) {
      if (withdrawals.has(id)) continue;
      withdrawals.add(id);
      void request(withdrawalEndpoint, { schema_version: 1, submission_id: id });
    }
  }

  return Object.freeze({ send, withdrawKnownAttempts, rememberAttemptForWithdrawal });
}

if (typeof module !== 'undefined' && module.exports) module.exports = { createWerkeServiceRequestTransport, readWerkeExistingFbpCookie };


  /* BEGIN FIRST PARTY CONFIG */
  const transportConfig = Object.freeze({ enabled: true, serviceEndpoint: 'https://werke-tracking-receiver.onrender.com/v1/service-requests', approvedReceiverOrigin: 'https://werke-tracking-receiver.onrender.com', matchingEnabled: true, ga4MeasurementId: 'G-1P78QXZTRD' });
  /* END FIRST PARTY CONFIG */
  const transport = createWerkeServiceRequestTransport(transportConfig, {
    currentOrigin: window.location.origin,
    fetch: (url, options) => window.fetch(url, options),
    customerPrivacy: () => window.Shopify && window.Shopify.customerPrivacy,
    now: () => Date.now(),
    readFbp: () => readWerkeExistingFbpCookie(document.cookie),
    userAgent: () => navigator.userAgent,
    getGtag: () => typeof window.gtag === 'function' ? window.gtag : null,
    setTimeout: (fn, ms) => window.setTimeout(fn, ms),
    clearTimeout: (id) => window.clearTimeout(id),
  });
  if (!transport) return;
  const allowedPaths = new Map([
    ['pagefly_home_service_request', '/'],
    ['pagefly_service_request', '/pages/contact-us'],
  ]);
  const allowedHosts = new Set(['werkeautosport.com', 'www.werkeautosport.com']);
  const maxAgeMs = 30 * 60 * 1000;
  const records = [];
  let retries = 0;
  let timer = null;
  let privacyRequested = false;

  if (window.location.protocol !== 'https:' || !allowedHosts.has(window.location.hostname)) return;

  const permission = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      const methods = ['analyticsProcessingAllowed', 'marketingAllowed', 'saleOfDataAllowed'];
      if (!privacy || methods.some((name) => typeof privacy[name] !== 'function')) return null;
      const states = methods.map((name) => privacy[name]());
      if (states.some((state) => state === false)) return false;
      return states.every((state) => state === true) ? true : null;
    } catch (_) {
      return null;
    }
  };

  const discard = (record) => {
    record.candidate = null;
    try { window.sessionStorage.removeItem(record.key); } catch (_) {}
  };

  const write = (record, value) => {
    try {
      const serialized = JSON.stringify(value);
      window.sessionStorage.setItem(record.key, serialized);
      return window.sessionStorage.getItem(record.key) === serialized;
    } catch (_) {
      return false;
    }
  };

  const read = (record) => {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(record.key));
      if (!value || Object.keys(value).sort().join(',') !== 'created_at,id,state') return null;
      if (value.state !== 'pending' || typeof value.id !== 'string') return null;
      if (!/^(?:[a-f0-9]{32}|[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12})$/.test(value.id)) return null;
      const age = Date.now() - value.created_at;
      if (!Number.isSafeInteger(value.created_at) || age < 0 || age > maxAgeMs) return null;
      return value;
    } catch (_) {
      return null;
    }
  };

  const createId = () => {
    if (!window.crypto) return null;
    if (typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (typeof window.crypto.getRandomValues !== 'function') return null;
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  };

  const attempt = () => {
    timer = null;
    const allowed = permission();
    if (allowed === false) {
      records.forEach(discard);
      transport.withdrawKnownAttempts();
      return;
    }

    if (allowed === true) {
      records.forEach((record) => {
        if (!record.captured) {
          record.captured = true;
          if (!record.submitted && record.accepted) record.candidate = read(record);
        }
        const candidate = record.candidate;
        if (!candidate) return;
        if (Date.now() - candidate.created_at > maxAgeMs || Date.now() < candidate.created_at) {
          discard(record);
          return;
        }
        if (permission() !== true) return;
        if (!write(record, { ...candidate, state: 'attempted' })) return;
        record.candidate = null;
        try {
          const result = transport.send({
            schema_version: 1,
            submission_id: candidate.id,
            form_id: record.id,
          });
          if (result && typeof result.catch === 'function') result.catch(() => {});
        } catch (_) {}
      });
    }

    if (retries < 50 && records.some((record) => !record.captured || record.candidate)) {
      retries += 1;
      timer = window.setTimeout(attempt, 100);
    }
  };

  const refresh = () => {
    if (timer !== null) window.clearTimeout(timer);
    attempt();
  };

  const initialize = () => {
    const ids = new Set();
    document.querySelectorAll('[data-werke-service-request-form]').forEach((marker) => {
      const id = marker.dataset.werkeServiceRequestForm;
      const form = marker.closest('form');
      if (!form || ids.has(id) || allowedPaths.get(id) !== window.location.pathname) return;
      const record = {
        id,
        key: `werke_autosport:service_request:v2:${id}`,
        accepted: marker.dataset.werkeServiceRequestAccepted === 'true',
        captured: false,
        submitted: false,
        candidate: null,
      };
      ids.add(id);
      records.push(record);
      // Existing attempted state is read only for consent withdrawal after a
      // same-tab reload; the adapter never re-enqueues or extends this record.
      try {
        transport.rememberAttemptForWithdrawal(JSON.parse(window.sessionStorage.getItem(record.key)));
      } catch (_) {}
      form.addEventListener('submit', (event) => {
        record.candidate = null;
        record.captured = true;
        if (event.isTrusted !== true || !form.checkValidity()) return;
        if (permission() !== true) {
          discard(record);
          return;
        }
        if (record.submitted) return;
        try {
          const id = createId();
          if (id && write(record, { id, created_at: Date.now(), state: 'pending' })) record.submitted = true;
        } catch (_) {}
      });
    });
    document.addEventListener('visitorConsentCollected', refresh);
    if (permission() === null && window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !privacyRequested) {
      privacyRequested = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) refresh();
        });
      } catch (_) {}
    }
    refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
